module.exports = __webpack_public_path__ + "18bf2c6892b1c4cf9f0fe57bd7e66738.png";